import React from "react";
import PropTypes from "prop-types";
import createReactClass from "create-react-class";

import CapacityBar from "./capacity_bar";

export default createReactClass({
  displayName: "Root",
  propTypes: {
    isOpen: PropTypes.bool.isRequired,
    closeModal: PropTypes.func.isRequired,
    fadeClassName: PropTypes.string.isRequired,
    publicTypeData: PropTypes.object.isRequired,
    initialTitle: PropTypes.string.isRequired,
    initialPublicType: PropTypes.number.isRequired,
    circleId: PropTypes.number.isRequired,
    photoStrageLimit: PropTypes.number.isRequired,
    chargePlanType: PropTypes.number.isRequired,
    isCirclePrivate: PropTypes.bool.isRequired,
    showAlbumCreateError: PropTypes.func.isRequired,
    showNetworkError: PropTypes.func.isRequired,
    showPublicSettingError: PropTypes.func.isRequired,
    showStrageError: PropTypes.func.isRequired,
    initialDesctription: PropTypes.string,
    userId: PropTypes.number,
    albumId: PropTypes.number,
    isEditMode: PropTypes.bool,
  },
  getInitialState() {
    return {
      title: this.props.initialTitle,
      publicType: this.props.initialPublicType,
      description: this.props.initialDesctription,
      isUploading: false,
      tempAlbumFileCapacity: 0,
      tempAllFileCapacity: 0,
    };
  },
  componentDidMount() {
    if (this.props.isEditMode) {
      this.loadTempFileCapacity(this.state.publicType);
    }
  },
  createAlbumToServer() {
    $.ajax({
      url: "/api/album/create_album",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        circle_id: this.props.circleId,
        user_id: this.props.userId,
        title: this.state.title,
        public_type: this.state.publicType,
        description: this.state.description,
      },
      cache: false,
      success: function(data) {
        if (data) {
          window.location.href =
            "/circle/" + this.props.circleId + "/album/" + data;
        } else {
          this.setState({
            isUploading: false,
          });
          this.props.showAlbumCreateError();
        }
      }.bind(this),
      error: function() {
        this.setState({
          isUploading: false,
        });
        this.props.showNetworkError();
      }.bind(this),
    });
  },
  updateAlbumToServer() {
    $.ajax({
      url: "/api/album/update_album",
      type: "POST",
      dataType: "json",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        album_id: this.props.albumId,
        title: this.state.title,
        public_type: this.state.publicType,
        description: this.state.description,
      },
      cache: false,
      success: function(data) {
        if (data != false) {
          window.location.href =
            "/circle/" + this.props.circleId + "/album/" + this.props.albumId;
        } else {
          this.setState({
            isUploading: false,
          });
          this.props.showAlbumCreateError();
        }
      }.bind(this),
      error: function() {
        this.setState({
          isUploading: false,
        });
        this.props.showNetworkError();
      }.bind(this),
    });
  },
  loadTempFileCapacity(publicType) {
    if (this.props.chargePlanType != 0) {
      return;
    }
    $.ajax({
      url: "/api/album/get_temp_file_capacity",
      type: "POST",
      headers: {
        "X-CSRF-Token": document.getElementsByName("csrf-token")[0].content,
      },
      data: {
        public_type: publicType,
        initial_public_type: this.props.initialPublicType,
        circle_id: this.props.circleId,
        album_id: this.props.albumId,
      },
      cache: false,
      success: function(data) {
        this.setState({
          tempAlbumFileCapacity: data.tempAlbumFileCapacity,
          tempAllFileCapacity: data.tempAllFileCapacity,
        });
      }.bind(this),
      error: function() {}.bind(this),
    });
  },
  onChangeTitleText(e) {
    this.setState({
      title: e.target.value,
    });
  },
  onChanePublicType(e) {
    this.setState({
      publicType: e.target.value,
    });
    if (this.props.isEditMode) {
      this.loadTempFileCapacity(e.target.value);
    }
  },
  onChangeDescriptionText(e) {
    this.setState({
      description: e.target.value,
    });
  },
  handleClose() {
    this.props.closeModal();
    this.loadTempFileCapacity(this.props.initialPublicType);
    setTimeout(
      function() {
        this.setState({
          title: this.props.initialTitle,
          publicType: this.props.initialPublicType,
          description: this.props.initialDesctription,
          isUploading: false,
        });
      }.bind(this),
      300
    );
  },
  handleCreateButton() {
    if (this.props.isCirclePrivate) {
      if (this.state.publicType == 4) {
        this.props.showPublicSettingError();
        return;
      }
    }
    if (this.props.isEditMode) {
      if (
        this.state.publicType == 2 &&
        this.props.initialPublicType == 4 &&
        this.state.tempAllFileCapacity >= this.props.photoStrageLimit
      ) {
        this.props.showStrageError();
      } else {
        this.setState({
          isUploading: true,
        });
        this.updateAlbumToServer();
      }
    } else {
      if (
        this.state.publicType == 2 &&
        this.props.allFileCapacity >= this.props.photoStrageLimit
      ) {
        this.props.showStrageError();
      } else {
        this.setState({
          isUploading: true,
        });
        this.createAlbumToServer();
      }
    }
  },
  render() {
    if (!this.props.isOpen) {
      return null;
    }
    // 公開範囲は選択肢が2つなので、選択欄ではなくラジオボタンにする
    // （承認ずみのプロフィール登録画面の決まり: 選択肢が2〜3個ならラジオボタン）。
    // 選んだときの処理は選択欄のときと同じ onChanePublicType
    var publicTypeNotes = {
      2: "サークルの正式メンバーのみ閲覧できます",
      4: "誰でも閲覧できます",
    };
    // 表示名だけ差し替える（元の名前は config/settings.yml の「公開」。値は変えない）
    var publicTypeLabels = { 4: "一般公開" };
    var optionsForSelectInput = [];
    for (var i in this.props.publicTypeData) {
      optionsForSelectInput.unshift(
        <label className="alb-modal__radio" key={i}>
          <input
            type="radio"
            className="alb-modal__radio-input"
            name="album_public_type"
            value={i}
            checked={String(this.state.publicType) === String(i)}
            onChange={this.onChanePublicType}
          />
          <span className="alb-modal__radio-text">
            <span className="alb-modal__radio-name">
              {publicTypeLabels[i] || this.props.publicTypeData[i].name}
            </span>
            <span className="alb-modal__radio-note">
              {publicTypeNotes[i] || ""}
            </span>
          </span>
        </label>
      );
    }
    var buttonName = this.props.isEditMode ? "保存" : "作成";
    var modalTitle = this.props.isEditMode ? "アルバムを編集" : "アルバムを作成";
    var modalLoading = "";
    if (this.state.isUploading) {
      modalLoading = (
        <div id="modal-loading">
          <div id="loader">
            <i className="fas fa-spinner fa-pulse fa-2x fa-fw" />
          </div>
        </div>
      );
    }
    var capacityBar = "";
    if (this.props.chargePlanType == 0) {
      if (this.props.isEditMode) {
        capacityBar = (
          <CapacityBar
            allFileCapacity={this.state.tempAllFileCapacity}
            albumFileCapacity={this.state.tempAlbumFileCapacity}
            photoStrageLimit={this.props.photoStrageLimit}
          />
        );
      } else {
        capacityBar = (
          <CapacityBar
            allFileCapacity={this.props.allFileCapacity}
            photoStrageLimit={this.props.photoStrageLimit}
          />
        );
      }
    }

    return (
      <div className="album-create-modal alb-modal">
        <div id={this.props.fadeClassName}>
          <div id="overAll">
            <div onClick={this.handleClose} id="overlay" />
            <div id="dialog">
              <div id="content" role="dialog" aria-label={modalTitle}>
                {modalLoading}
                {/* 見出しと閉じる。承認ずみの「地域を選択」「サークルを選択」のモーダルと同じ形 */}
                <div className="alb-modal__head">
                  <p className="alb-modal__title">{modalTitle}</p>
                  <button
                    type="button"
                    className="alb-modal__close"
                    aria-label="閉じる"
                    onClick={this.handleClose}
                  >
                    ×
                  </button>
                </div>
                <div id="body" className="alb-modal__body">
                  <div className="alb-modal__field">
                    <label className="alb-modal__label" htmlFor="album_title_input">
                      アルバム名
                    </label>
                    <input
                      id="album_title_input"
                      type="text"
                      className="alb-modal__input"
                      value={this.state.title}
                      placeholder="無題のアルバム"
                      onChange={this.onChangeTitleText}
                    />
                  </div>
                  <div className="alb-modal__field">
                    <p className="alb-modal__label">公開範囲</p>
                    <div className="alb-modal__radios" role="radiogroup" aria-label="公開範囲">
                      {optionsForSelectInput}
                    </div>
                    {this.props.isCirclePrivate ? (
                      <p className="alb-modal__help">
                        このサークルは非公開のため、「一般公開」は選べません。
                      </p>
                    ) : (
                      ""
                    )}
                    {/* 保存容量は「サークル内限定」を選んだときだけ出す（容量を使うのは限定の写真だけなので） */}
                    {capacityBar && String(this.state.publicType) === "2" ? (
                      <div className="alb-modal__capacity">
                        <p className="alb-modal__capacity-label">
                          サークル内限定の写真の保存容量
                        </p>
                        {capacityBar}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="alb-modal__field">
                    <label className="alb-modal__label" htmlFor="album_description_input">
                      説明
                      <span className="alb-modal__optional">任意</span>
                    </label>
                    <textarea
                      id="album_description_input"
                      className="alb-modal__textarea"
                      value={this.state.description}
                      placeholder="どんなイベントの写真か、ひとこと添えましょう"
                      rows="3"
                      onChange={this.onChangeDescriptionText}
                    />
                  </div>
                </div>
                <div id="footer" className="alb-modal__foot">
                  <button
                    type="button"
                    className="alb-modal__btn alb-modal__btn--sub"
                    id="album_cancel_button"
                    onClick={this.handleClose}
                  >
                    キャンセル
                  </button>
                  <button
                    type="button"
                    className="alb-modal__btn alb-modal__btn--main"
                    id="album_submit_button"
                    onClick={this.handleCreateButton}
                  >
                    {buttonName}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
